<script>
import { LogViewAllRelatesAdsClicked, LogFactBoxLinkClicked } from '@/events'

export default {
  template: '<template></template>',
  mounted() {
    const containers = document.getElementsByClassName('container')

    Array.from(containers).forEach(container => {
      this.handleViewAllRelatesAdsLink(container)
      this.handleFactBoxLink(container)
    })
  },
  methods: {
    handleFactBoxLink(container) {
      this.handleLink(container, 'fact-box__button', () => {
        LogFactBoxLinkClicked()
      })
    },
    handleViewAllRelatesAdsLink(container) {
      this.handleLink(container, 'js-license-plate-view-all-ads', () => {
        LogViewAllRelatesAdsClicked()
      })
    },
    handleLink(container, className, callback, eventName = 'click') {
      const links = container.getElementsByClassName(className)

      Array.from(links).forEach(link => {
        link.addEventListener(eventName, () => {
          callback()
        })
      })
    },
  },
}
</script>

<style lang="scss">
@use '../../FactBox/FactBox';
@use '../../ArticleItem/ArticleItem';
@use '../../ArticleContainer/ArticleContainer';
@use '../../ShortcutBanner/ShortcutBanner';
</style>
